import SpotCard from './SpotCard';

/**
 * SpotList - スポット一覧コンポーネント
 *
 * @param {{ spots: Array, campaignId: string }} props
 */
const SpotList = ({ spots, campaignId }) => {
  if (!spots || spots.length === 0) {
    return (
      <div className="text-center py-10 px-4">
        <p className="text-gray-500 text-sm">スポット情報がありません</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-x-2 gap-y-6 px-4 py-4">
      {spots.map((spot, index) => (
        <SpotCard
          key={spot.id}
          spot={spot}
          campaignId={campaignId}
          displayIndex={index + 1}
        />
      ))}
    </div>
  );
};

export default SpotList;
